<div class="burger-menu">
  <span></span>
  <span></span>
  <span></span>
</div>
